export const STILL = 'STILL'
export const LEFT_SLIDE = 'LEFT_SLIDE'
export const RIGHT_SLIDE = 'RIGHT_SLIDE'
